import { render, staticRenderFns } from "./imgCover.vue?vue&type=template&id=fda0f07c&scoped=true"
import script from "./imgCover.vue?vue&type=script&lang=js"
export * from "./imgCover.vue?vue&type=script&lang=js"
import style0 from "./imgCover.vue?vue&type=style&index=0&id=fda0f07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda0f07c",
  null
  
)

export default component.exports